import axios from "axios";
class ApiRoaming {
    static async GetRoamingZones() {
        try {
            const result = await axios.get((process.env.VUE_APP_API_PATH || "/") + "api/public/roaming/get-zones", {});
            return result.data.data;
        }
        catch (e) {
            throw new Error("Error get roaming zones");
        }
    }
    static async GetRoamingZoneByUUID(session_uuid, zone_uuid) {
        try {
            const result = await axios.post((process.env.VUE_APP_API_PATH || "/") +
                "api/public/roaming/get-zone-by", {
                uuid: zone_uuid,
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            console.log("Error get roaming zone");
            return undefined;
        }
    }
    static async CreateRoamingZone(session_uuid, zone_name, zone_order, group_1_call_price, group_2_call_price, group_3_call_price, group_4_call_price, group_5_call_price, group_1_sms_price, group_2_sms_price, group_3_sms_price, group_4_sms_price, group_5_sms_price, incoming_call_price, data_mb_price) {
        try {
            const result = await axios.post((process.env.VUE_APP_API_PATH || "/") +
                "api/admin/roaming/create-zone", {
                zone_name: zone_name,
                zone_order: zone_order,
                group_1_call_price: group_1_call_price,
                group_2_call_price: group_2_call_price,
                group_3_call_price: group_3_call_price,
                group_4_call_price: group_4_call_price,
                group_5_call_price: group_5_call_price,
                group_1_sms_price: group_1_sms_price,
                group_2_sms_price: group_2_sms_price,
                group_3_sms_price: group_3_sms_price,
                group_4_sms_price: group_4_sms_price,
                group_5_sms_price: group_5_sms_price,
                incoming_call_price: incoming_call_price,
                data_mb_price: data_mb_price,
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            console.log("result: ", result);
            return result.data.response.zone_uuid;
        }
        catch (e) {
            console.error(e);
            if ("response" in e &&
                "data" in e.response &&
                "response" in e.response.data) {
                console.log("Error create roaming zone");
                return e.response.data.response;
            }
        }
        return undefined;
    }
    static async UpdateRoamingZone(session_uuid, zone_name, zone_order, group_1_call_price, group_2_call_price, group_3_call_price, group_4_call_price, group_5_call_price, group_1_sms_price, group_2_sms_price, group_3_sms_price, group_4_sms_price, group_5_sms_price, incoming_call_price, data_mb_price, uuid) {
        try {
            const result = await axios.post((process.env.VUE_APP_API_PATH || "/") + "api/admin/roaming/update-zone", {
                zone_name: zone_name,
                zone_order: zone_order,
                group_1_call_price: group_1_call_price,
                group_2_call_price: group_2_call_price,
                group_3_call_price: group_3_call_price,
                group_4_call_price: group_4_call_price,
                group_5_call_price: group_5_call_price,
                group_1_sms_price: group_1_sms_price,
                group_2_sms_price: group_2_sms_price,
                group_3_sms_price: group_3_sms_price,
                group_4_sms_price: group_4_sms_price,
                group_5_sms_price: group_5_sms_price,
                incoming_call_price: incoming_call_price,
                data_mb_price: data_mb_price,
                uuid: uuid,
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            console.log("Error update roaming zone");
        }
    }
    static async DeleteRoamingZone(session_uuid, uuid) {
        try {
            const result = await axios.post((process.env.VUE_APP_API_PATH || "/") + "api/admin/roaming/delete-zone", { uuid: uuid }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            console.log("Error delete roaming zone");
            return;
        }
    }
}
export default ApiRoaming;
